import type { SupportingDocInput } from "@/types";

export async function readSupportingDocumentsAsBase64(docs: SupportingDocInput[]) {
  if (!docs.length) return [];

  return Promise.all(
    docs.map(async (doc) => {
      const fileBase64 = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target?.result) resolve(e.target.result as string);
          else reject(new Error("Failed to read file"));
        };
        reader.onerror = () => reject(new Error("Failed to read file"));
        reader.readAsDataURL(doc.file);
      });

      return {
        fileName: doc.file.name,
        docType: doc.docType,
        fileBase64,
      };
    })
  );
}
